var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "basic-container",
    [
      _c(
        "el-row",
        { attrs: { span: 24 } },
        [
          _c("el-col", { attrs: { md: 4 } }, [
            _c(
              "div",
              { staticClass: "tree-position" },
              [
                _c("avue-tree", {
                  attrs: { data: _vm.treeData, option: _vm.treeOption },
                  on: { "node-click": _vm.nodeClick },
                }),
              ],
              1
            ),
          ]),
          _c(
            "el-col",
            { attrs: { md: 20 } },
            [
              _c(
                "el-tabs",
                {
                  on: { "tab-click": _vm.handleClick },
                  model: {
                    value: _vm.materialType,
                    callback: function ($$v) {
                      _vm.materialType = $$v
                    },
                    expression: "materialType",
                  },
                },
                [
                  _c(
                    "el-tab-pane",
                    { attrs: { name: "image" } },
                    [
                      _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                        _c("i", { staticClass: "el-icon-picture" }),
                        _vm._v("\n\t\t\t\t\t\t图片\n\t\t\t\t\t"),
                      ]),
                      _c(
                        "div",
                        { staticClass: "add_but" },
                        [
                          _c(
                            "el-upload",
                            {
                              attrs: {
                                action: _vm.actionUrl,
                                "before-upload": _vm.beforeImageUpload,
                                data: _vm.uploadData,
                                "file-list": _vm.fileList,
                                headers: _vm.headers,
                                limit: 1,
                                "on-success": _vm.handleUploadSuccess,
                                multiple: "",
                              },
                            },
                            [
                              _vm.permissions.mp_wxmaterial_add
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { size: "mini", type: "primary" },
                                    },
                                    [_vm._v("点击上传")]
                                  )
                                : _vm._e(),
                              _c(
                                "div",
                                {
                                  staticClass: "el-upload__tip",
                                  attrs: { slot: "tip" },
                                  slot: "tip",
                                },
                                [
                                  _vm._v(
                                    "支持bmp/png/jpeg/jpg/gif格式，大小不超过5M"
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.tableLoading,
                              expression: "tableLoading",
                            },
                          ],
                          staticClass: "waterfall",
                        },
                        _vm._l(_vm.tableData, function (item) {
                          return _c(
                            "div",
                            { key: item.id, staticClass: "waterfall-item" },
                            [
                              _c(
                                "a",
                                { attrs: { href: item.url, target: "_blank" } },
                                [
                                  _c("img", {
                                    staticClass: "material-img",
                                    attrs: { src: item.url },
                                  }),
                                  _c("div", { staticClass: "item-name" }, [
                                    _vm._v(_vm._s(item.name)),
                                  ]),
                                ]
                              ),
                              _c(
                                "el-row",
                                { staticClass: "ope-row" },
                                [
                                  _vm.permissions.mp_wxmaterial_del
                                    ? _c("el-button", {
                                        attrs: {
                                          circle: "",
                                          icon: "el-icon-delete",
                                          type: "danger",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.delMaterial(item)
                                          },
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        }),
                        0
                      ),
                      _vm.tableData.length <= 0 && !_vm.tableLoading
                        ? _c("div", { staticClass: "el-table__empty-block" }, [
                            _c(
                              "span",
                              { staticClass: "el-table__empty-text" },
                              [_vm._v("暂无数据")]
                            ),
                          ])
                        : _vm._e(),
                      _c("el-pagination", {
                        staticClass: "pagination",
                        attrs: {
                          "current-page": _vm.page.currentPage,
                          "page-size": _vm.page.pageSize,
                          "page-sizes": [10, 20],
                          total: _vm.page.total,
                          layout: "total, sizes, prev, pager, next, jumper",
                        },
                        on: {
                          "update:currentPage": function ($event) {
                            return _vm.$set(_vm.page, "currentPage", $event)
                          },
                          "update:current-page": function ($event) {
                            return _vm.$set(_vm.page, "currentPage", $event)
                          },
                          "size-change": _vm.sizeChange,
                          "current-change": _vm.currentChange,
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-tab-pane",
                    { attrs: { name: "voice" } },
                    [
                      _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                        _c("i", { staticClass: "el-icon-microphone" }),
                        _vm._v("\n\t\t\t\t\t\t语音\n\t\t\t\t\t"),
                      ]),
                      _c(
                        "div",
                        { staticClass: "add_but" },
                        [
                          _c(
                            "el-upload",
                            {
                              attrs: {
                                action: _vm.actionUrl,
                                "before-upload": _vm.beforeVoiceUpload,
                                data: _vm.uploadData,
                                "file-list": _vm.fileList,
                                headers: _vm.headers,
                                limit: 1,
                                "on-success": _vm.handleUploadSuccess,
                                multiple: "",
                              },
                            },
                            [
                              _vm.permissions.mp_wxmaterial_add
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { size: "mini", type: "primary" },
                                    },
                                    [_vm._v("点击上传")]
                                  )
                                : _vm._e(),
                              _c(
                                "div",
                                {
                                  staticClass: "el-upload__tip",
                                  attrs: { slot: "tip" },
                                  slot: "tip",
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t格式支持mp3/wma/wav/amr，文件大小不超过2M，播放长度不超过60s\n\t\t\t\t\t\t\t"
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-table",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.tableLoading,
                              expression: "tableLoading",
                            },
                          ],
                          attrs: {
                            data: _vm.tableData,
                            border: "",
                            stripe: "",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: { label: "media_id", prop: "mediaId" },
                          }),
                          _c("el-table-column", {
                            attrs: { label: "名称", prop: "name" },
                          }),
                          _c("el-table-column", {
                            attrs: { label: "更新时间", prop: "updateTime" },
                          }),
                          _c("el-table-column", {
                            attrs: { fixed: "right", label: "操作" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          icon: "el-icon-download",
                                          plain: "",
                                          size: "small",
                                          type: "text",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleDown(scope.row)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t\t下载\n\t\t\t\t\t\t\t\t"
                                        ),
                                      ]
                                    ),
                                    _vm.permissions.mp_wxmaterial_del
                                      ? _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              icon: "el-icon-delete",
                                              plain: "",
                                              size: "small",
                                              type: "text",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.delMaterial(
                                                  scope.row
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t\t删除\n\t\t\t\t\t\t\t\t"
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                      _c("el-pagination", {
                        staticClass: "pagination",
                        attrs: {
                          "current-page": _vm.page.currentPage,
                          "page-size": _vm.page.pageSize,
                          "page-sizes": [10, 20],
                          total: _vm.page.total,
                          layout: "total, sizes, prev, pager, next, jumper",
                        },
                        on: {
                          "update:currentPage": function ($event) {
                            return _vm.$set(_vm.page, "currentPage", $event)
                          },
                          "update:current-page": function ($event) {
                            return _vm.$set(_vm.page, "currentPage", $event)
                          },
                          "size-change": _vm.sizeChange,
                          "current-change": _vm.currentChange,
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-tab-pane",
                    { attrs: { name: "video" } },
                    [
                      _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                        _c("i", { staticClass: "el-icon-video-play" }),
                        _vm._v("\n\t\t\t\t\t\t视频\n\t\t\t\t\t"),
                      ]),
                      _c(
                        "div",
                        { staticClass: "add_but" },
                        [
                          _vm.permissions.mp_wxmaterial_add
                            ? _c(
                                "el-button",
                                {
                                  attrs: { size: "mini", type: "primary" },
                                  on: { click: _vm.handleAddVideo },
                                },
                                [_vm._v("\n\t\t\t\t\t\t\t新建\n\t\t\t\t\t\t")]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        "el-dialog",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.addMaterialLoading,
                              expression: "addMaterialLoading",
                            },
                          ],
                          attrs: {
                            visible: _vm.dialogVideoVisible,
                            title: "新建视频",
                          },
                          on: {
                            "update:visible": function ($event) {
                              _vm.dialogVideoVisible = $event
                            },
                          },
                        },
                        [
                          _c(
                            "el-upload",
                            {
                              ref: "uploadVideo",
                              attrs: {
                                action: _vm.actionUrl,
                                "auto-upload": false,
                                "before-upload": _vm.beforeVideoUpload,
                                data: _vm.uploadData,
                                "file-list": _vm.fileList,
                                headers: _vm.headers,
                                limit: 1,
                                "on-success": _vm.handleUploadSuccess,
                                multiple: "",
                              },
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    slot: "trigger",
                                    size: "mini",
                                    type: "primary",
                                  },
                                  slot: "trigger",
                                },
                                [_vm._v("选择视频")]
                              ),
                              _c("div", { staticClass: "el-upload__tip" }, [
                                _vm._v("格式支持MP4，文件大小不超过10MB"),
                              ]),
                            ],
                            1
                          ),
                          _c(
                            "el-form",
                            {
                              ref: "uploadForm",
                              attrs: {
                                model: _vm.uploadData,
                                rules: _vm.uploadRules,
                              },
                            },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "标题", prop: "title" } },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      placeholder:
                                        "标题将展示在相关播放页面，建议填写清晰、准确、生动的标题",
                                    },
                                    model: {
                                      value: _vm.uploadData.title,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.uploadData, "title", $$v)
                                      },
                                      expression: "uploadData.title",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "描述",
                                    prop: "introduction",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      rows: 3,
                                      placeholder:
                                        "介绍语将展示在相关播放页面，建议填写简洁明确、有信息量的内容",
                                      type: "textarea",
                                    },
                                    model: {
                                      value: _vm.uploadData.introduction,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.uploadData,
                                          "introduction",
                                          $$v
                                        )
                                      },
                                      expression: "uploadData.introduction",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "dialog-footer",
                              attrs: { slot: "footer" },
                              slot: "footer",
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  on: {
                                    click: function ($event) {
                                      _vm.dialogVideoVisible = false
                                    },
                                  },
                                },
                                [_vm._v("取 消")]
                              ),
                              _vm.permissions.mp_wxmaterial_add
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { type: "primary" },
                                      on: { click: _vm.subVideo },
                                    },
                                    [_vm._v("提 交")]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-table",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.tableLoading,
                              expression: "tableLoading",
                            },
                          ],
                          attrs: {
                            data: _vm.tableData,
                            border: "",
                            stripe: "",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: { label: "media_id", prop: "mediaId" },
                          }),
                          _c("el-table-column", {
                            attrs: { label: "名称", prop: "name" },
                          }),
                          _c("el-table-column", {
                            attrs: { label: "更新时间", prop: "updateTime" },
                          }),
                          _c("el-table-column", {
                            attrs: { fixed: "right", label: "操作" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          icon: "el-icon-view",
                                          plain: "",
                                          size: "small",
                                          type: "text",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleInfo(scope.row)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t\t查看\n\t\t\t\t\t\t\t\t"
                                        ),
                                      ]
                                    ),
                                    _vm.permissions.mp_wxmaterial_del
                                      ? _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              icon: "el-icon-delete",
                                              plain: "",
                                              size: "small",
                                              type: "text",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.delMaterial(
                                                  scope.row
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t\t删除\n\t\t\t\t\t\t\t\t"
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                      _c("el-pagination", {
                        staticClass: "pagination",
                        attrs: {
                          "current-page": _vm.page.currentPage,
                          "page-size": _vm.page.pageSize,
                          "page-sizes": [10, 20],
                          total: _vm.page.total,
                          layout: "total, sizes, prev, pager, next, jumper",
                        },
                        on: {
                          "update:currentPage": function ($event) {
                            return _vm.$set(_vm.page, "currentPage", $event)
                          },
                          "update:current-page": function ($event) {
                            return _vm.$set(_vm.page, "currentPage", $event)
                          },
                          "size-change": _vm.sizeChange,
                          "current-change": _vm.currentChange,
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-tab-pane",
                    { attrs: { name: "news" } },
                    [
                      _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                        _c("i", { staticClass: "el-icon-news" }),
                        _vm._v("\n\t\t\t\t\t\t图文\n\t\t\t\t\t"),
                      ]),
                      _c(
                        "div",
                        { staticClass: "add_but" },
                        [
                          _vm.permissions.mp_wxmaterial_add
                            ? _c(
                                "el-button",
                                {
                                  attrs: { size: "mini", type: "primary" },
                                  on: { click: _vm.handleAddNews },
                                },
                                [_vm._v("\n\t\t\t\t\t\t\t新 增\n\t\t\t\t\t\t")]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        "el-dialog",
                        {
                          attrs: {
                            "before-close": _vm.dialogNewsClose,
                            "close-on-click-modal": false,
                            title:
                              _vm.operateMaterial == "add"
                                ? "新建图文"
                                : "修改图文",
                            visible: _vm.dialogNewsVisible,
                            top: "20px",
                            width: "80%",
                          },
                          on: {
                            "update:visible": function ($event) {
                              _vm.dialogNewsVisible = $event
                            },
                          },
                        },
                        [
                          _c("div", { staticClass: "left" }, [
                            _c(
                              "div",
                              { staticClass: "select-item" },
                              [
                                _vm._l(_vm.articlesAdd, function (news, index) {
                                  return _c("div", { key: news.id }, [
                                    index == 0
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "news-main father",
                                            class: {
                                              activeAddNews:
                                                _vm.isActiveAddNews == index,
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.activeNews(index)
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "news-content" },
                                              [
                                                news.thumbUrl
                                                  ? _c("img", {
                                                      staticClass:
                                                        "material-img",
                                                      attrs: {
                                                        src: news.thumbUrl,
                                                      },
                                                    })
                                                  : _vm._e(),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "news-content-title",
                                                  },
                                                  [_vm._v(_vm._s(news.title))]
                                                ),
                                              ]
                                            ),
                                            _vm.articlesAdd.length > 1
                                              ? _c(
                                                  "div",
                                                  { staticClass: "child" },
                                                  [
                                                    _c(
                                                      "el-button",
                                                      {
                                                        attrs: {
                                                          icon: "el-icon-sort-down",
                                                          type: "mini",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.downNews(
                                                              index
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [_vm._v("下移")]
                                                    ),
                                                    _vm.operateMaterial == "add"
                                                      ? _c(
                                                          "el-button",
                                                          {
                                                            attrs: {
                                                              icon: "el-icon-delete",
                                                              type: "mini",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.minusNews(
                                                                  index
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n\t\t\t\t\t\t\t\t\t\t\t\t删除\n\t\t\t\t\t\t\t\t\t\t\t"
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                          ]
                                        )
                                      : _vm._e(),
                                    index > 0
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "news-main-item father",
                                            class: {
                                              activeAddNews:
                                                _vm.isActiveAddNews == index,
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.activeNews(index)
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "news-content-item",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "news-content-item-title",
                                                  },
                                                  [_vm._v(_vm._s(news.title))]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "news-content-item-img",
                                                  },
                                                  [
                                                    news.thumbUrl
                                                      ? _c("img", {
                                                          staticClass:
                                                            "material-img",
                                                          attrs: {
                                                            src: news.thumbUrl,
                                                            height: "100%",
                                                          },
                                                        })
                                                      : _vm._e(),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "child" },
                                              [
                                                _vm.articlesAdd.length >
                                                index + 1
                                                  ? _c(
                                                      "el-button",
                                                      {
                                                        attrs: {
                                                          icon: "el-icon-sort-down",
                                                          type: "mini",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.downNews(
                                                              index
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n\t\t\t\t\t\t\t\t\t\t\t\t下移\n\t\t\t\t\t\t\t\t\t\t\t"
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _c(
                                                  "el-button",
                                                  {
                                                    attrs: {
                                                      icon: "el-icon-sort-up",
                                                      type: "mini",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.upNews(index)
                                                      },
                                                    },
                                                  },
                                                  [_vm._v("上移")]
                                                ),
                                                _vm.operateMaterial == "add"
                                                  ? _c(
                                                      "el-button",
                                                      {
                                                        attrs: {
                                                          icon: "el-icon-delete",
                                                          type: "mini",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.minusNews(
                                                              index
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n\t\t\t\t\t\t\t\t\t\t\t\t删除\n\t\t\t\t\t\t\t\t\t\t\t"
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ],
                                              1
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ])
                                }),
                                _vm.articlesAdd.length < 8 &&
                                _vm.operateMaterial == "add"
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "news-main-plus",
                                        on: { click: _vm.plusNews },
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "el-icon-circle-plus icon-plus",
                                        }),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              2
                            ),
                          ]),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "loading",
                                  rawName: "v-loading",
                                  value: _vm.addMaterialLoading,
                                  expression: "addMaterialLoading",
                                },
                              ],
                              staticClass: "right",
                            },
                            [
                              _c(
                                "el-row",
                                [
                                  _vm.hackResetEditor
                                    ? _c("WxEditor", {
                                        attrs: { uploadData: _vm.uploadData },
                                        model: {
                                          value:
                                            _vm.articlesAdd[_vm.isActiveAddNews]
                                              .content,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.articlesAdd[
                                                _vm.isActiveAddNews
                                              ],
                                              "content",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "articlesAdd[isActiveAddNews].content",
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _c("br"),
                              _c("br"),
                              _c("br"),
                              _c("br"),
                              _c("div", { staticClass: "input-tt" }, [
                                _vm._v("封面和摘要："),
                              ]),
                              _c(
                                "div",
                                [
                                  _c("div", { staticClass: "thumb-div" }, [
                                    _vm.articlesAdd[_vm.isActiveAddNews]
                                      .thumbUrl
                                      ? _c("img", {
                                          staticClass: "material-img",
                                          class:
                                            _vm.isActiveAddNews == 0
                                              ? "avatar"
                                              : "avatar1",
                                          attrs: {
                                            src: _vm.articlesAdd[
                                              _vm.isActiveAddNews
                                            ].thumbUrl,
                                          },
                                        })
                                      : _c("i", {
                                          staticClass:
                                            "el-icon-plus avatar-uploader-icon",
                                          class:
                                            _vm.isActiveAddNews == 0
                                              ? "avatar"
                                              : "avatar1",
                                        }),
                                    _c(
                                      "div",
                                      { staticClass: "thumb-but" },
                                      [
                                        _c(
                                          "el-upload",
                                          {
                                            attrs: {
                                              action: _vm.actionUrl,
                                              "before-upload":
                                                _vm.beforeThumbImageUpload,
                                              data: _vm.uploadData,
                                              "file-list": _vm.fileList,
                                              headers: _vm.headers,
                                              limit: 1,
                                              "on-success":
                                                _vm.handleUploadSuccess,
                                              multiple: "",
                                            },
                                          },
                                          [
                                            _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  slot: "trigger",
                                                  size: "mini",
                                                  type: "primary",
                                                },
                                                slot: "trigger",
                                              },
                                              [_vm._v("本地上传")]
                                            ),
                                            _c(
                                              "el-button",
                                              {
                                                staticStyle: {
                                                  "margin-left": "5px",
                                                },
                                                attrs: {
                                                  size: "mini",
                                                  type: "primary",
                                                },
                                                on: { click: _vm.openMaterial },
                                              },
                                              [
                                                _vm._v(
                                                  "\n\t\t\t\t\t\t\t\t\t\t\t\t素材库选择\n\t\t\t\t\t\t\t\t\t\t\t"
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "el-upload__tip",
                                                attrs: { slot: "tip" },
                                                slot: "tip",
                                              },
                                              [
                                                _vm._v(
                                                  "支持bmp/png/jpeg/jpg/gif格式，大小不超过2M"
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ]),
                                  _c(
                                    "el-dialog",
                                    {
                                      attrs: {
                                        visible: _vm.dialogImageVisible,
                                        "append-to-body": "",
                                        title: "选择图片",
                                        width: "80%",
                                      },
                                      on: {
                                        "update:visible": function ($event) {
                                          _vm.dialogImageVisible = $event
                                        },
                                      },
                                    },
                                    [
                                      _c("WxMaterialSelect", {
                                        attrs: {
                                          objData: {
                                            repType: "image",
                                            appId: _vm.checkAppId,
                                          },
                                        },
                                        on: {
                                          selectMaterial: _vm.selectMaterial,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c("el-input", {
                                    staticClass: "digest",
                                    attrs: {
                                      rows: 8,
                                      maxlength: "120",
                                      placeholder: "请输入摘要",
                                      type: "textarea",
                                    },
                                    model: {
                                      value:
                                        _vm.articlesAdd[_vm.isActiveAddNews]
                                          .digest,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.articlesAdd[_vm.isActiveAddNews],
                                          "digest",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "articlesAdd[isActiveAddNews].digest",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c("div", { staticClass: "input-tt" }, [
                                _vm._v("标题："),
                              ]),
                              _c("el-input", {
                                attrs: { placeholder: "请输入标题" },
                                model: {
                                  value:
                                    _vm.articlesAdd[_vm.isActiveAddNews].title,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.articlesAdd[_vm.isActiveAddNews],
                                      "title",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "articlesAdd[isActiveAddNews].title",
                                },
                              }),
                              _c("div", { staticClass: "input-tt" }, [
                                _vm._v("作者："),
                              ]),
                              _c("el-input", {
                                attrs: { placeholder: "请输入作者" },
                                model: {
                                  value:
                                    _vm.articlesAdd[_vm.isActiveAddNews].author,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.articlesAdd[_vm.isActiveAddNews],
                                      "author",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "articlesAdd[isActiveAddNews].author",
                                },
                              }),
                              _c("div", { staticClass: "input-tt" }, [
                                _vm._v("原文地址："),
                              ]),
                              _c("el-input", {
                                attrs: { placeholder: "请输入原文地址" },
                                model: {
                                  value:
                                    _vm.articlesAdd[_vm.isActiveAddNews]
                                      .contentSourceUrl,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.articlesAdd[_vm.isActiveAddNews],
                                      "contentSourceUrl",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "articlesAdd[isActiveAddNews].contentSourceUrl",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "dialog-footer",
                              attrs: { slot: "footer" },
                              slot: "footer",
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  on: {
                                    click: function ($event) {
                                      _vm.dialogNewsVisible = false
                                    },
                                  },
                                },
                                [_vm._v("取 消")]
                              ),
                              _vm.permissions.mp_wxmaterial_add
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { type: "primary" },
                                      on: { click: _vm.subNews },
                                    },
                                    [_vm._v("提 交")]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.tableLoading,
                              expression: "tableLoading",
                            },
                          ],
                          staticClass: "waterfall",
                        },
                        _vm._l(_vm.tableData, function (item) {
                          return item.content && item.content.articles
                            ? _c(
                                "div",
                                { key: item.id, staticClass: "waterfall-item" },
                                [
                                  _c("WxNews", {
                                    attrs: { objData: item.content.articles },
                                  }),
                                  _c(
                                    "el-row",
                                    { staticClass: "ope-row" },
                                    [
                                      _c("el-button", {
                                        attrs: {
                                          circle: "",
                                          icon: "el-icon-edit",
                                          type: "primary",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleEditNews(item)
                                          },
                                        },
                                      }),
                                      _c("el-button", {
                                        attrs: {
                                          circle: "",
                                          icon: "el-icon-delete",
                                          type: "danger",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.delMaterial(item)
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e()
                        }),
                        0
                      ),
                      _vm.tableData.length <= 0 && !_vm.tableLoading
                        ? _c("div", { staticClass: "el-table__empty-block" }, [
                            _c(
                              "span",
                              { staticClass: "el-table__empty-text" },
                              [_vm._v("暂无数据")]
                            ),
                          ])
                        : _vm._e(),
                      _c("el-pagination", {
                        staticClass: "pagination",
                        attrs: {
                          "current-page": _vm.page.currentPage,
                          "page-size": _vm.page.pageSize,
                          "page-sizes": [10, 20],
                          total: _vm.page.total,
                          layout: "total, sizes, prev, pager, next, jumper",
                        },
                        on: {
                          "update:currentPage": function ($event) {
                            return _vm.$set(_vm.page, "currentPage", $event)
                          },
                          "update:current-page": function ($event) {
                            return _vm.$set(_vm.page, "currentPage", $event)
                          },
                          "size-change": _vm.sizeChange,
                          "current-change": _vm.currentChange,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }